export const sort_left = () => (
  <path
    d="M19 12H5m0 0l4 4m-4-4l4-4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
